import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    outcomesDatatypesList: []
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setOutcomesDatatypes(state, payload) {
      state.outcomesDatatypesList = payload
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("datatypes");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllForSource({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("datatypes/forSource", {
        params: { id: payload }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllForOutcome({ commit }, payload) {
      commit('setListLoading', true);
      let list = await api.get('datatypes/forOutcome', {
        params: { id: payload }
      });
      commit('setOutcomesDatatypes', list.data);
      commit('setListLoading', false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("datatypes", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`datatypes`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      // dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`datatypes/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    outcomesDatatypesList(state) {
      return state.outcomesDatatypesList
    }
  }
};
